import { combineReducers } from "redux";

import googleTagManager from "./googleTagManager";
import menu from "./menu";
import ads from "./ads";
import user from "./user";
import sidebarTopNews from "./sidebarTopNews";
import featuredNews from "./featuredNews";
import navigation from "./navigation";
import pagination from "./pagination";
import sidebarToggle from "./sidebarToggle";
import drawerToggle from "./drawerToggle";
import latestNews from "./latestNews";
import commentReply from "./commentReply";
import metaTags from "./metaTags";
import permissions from "./permissions";
import initData from "./initData";

export default combineReducers({
  googleTagManager,
  menu,
  ads,
  user,
  sidebarTopNews,
  featuredNews,
  navigation,
  pagination,
  sidebarToggle,
  drawerToggle,
  latestNews,
  commentReply,
  metaTags,
  permissions,
  initData
});
